import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { useDispatch, useSelector, connect } from "react-redux";
import {
  reduxForm,
  Field,
  initialize,
  formValueSelector,
  getFormValues,
} from "redux-form";
//import { CSSTransition } from "react-transition-group";
import { openModal, closeModal, fetchError } from "../../actions";
import { Form, Button, Grid, Menu, Container, Header } from "semantic-ui-react";
import {
  TextInput,
  SelectInput,
  CheckboxInput,
  FileInput,
  AdvertiserOptions,
} from "../utils/form-fields";
import { ColorPicker, ColorContrastView, checkUser } from "../utils/helpers";
import { createBanner, updateBanner, uploadFile } from "../../firebase";
import { CancelButton } from "../utils/buttons";
import Fastrade from "./fastrade";

const presetColors = [
  "#fcd700",
  "#00539F",
  "#000000",
  "#FFFFFF",
  "#850064",
  "#CD2397",
  "#8F4521",
  "#006A7D",
  "#3261AF",
  "#269CC4",
  "#005928",
  "#829A00",
  "#D9A300",
  "#FF4100",
  "#fbf0d5",
];

let BannerForm = ({
  formValues,
  change,
  submitting,
  pristine,
  handleSubmit,
  invalid,
  retailer,
  template,
  bg,
  font,
  panel,
  cta,
  chevron,
  vt,
  vtFont,
  vtWhite,
  primary,
  secondary,
  logo,
  bgImage,
  buylist,
  togglePower,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const banner = useSelector((state) => state.banner);
  const advertisers = useSelector((state) => state.advertisers || []);
  const user = useSelector((state) => state.user);
  const showFastrade = useSelector((state) => state.fastrade);
  //const template = useSelector((state) => state.template);

  const [showLoading, setShowLoading] = useState(false);
  const [hideFields, setHideFields] = useState(true);
  const [valueTileData, setValueTileData] = useState({});

  useEffect(() => {
    dispatch(initialize("bannerForm", banner));
    setShowLoading(false);
  }, [dispatch, banner]);

  useEffect(() => {
    // runs only once
    if (retailer === "tesco" && template) change("newValueTile", true);
  }, []);

  useEffect(() => {
    if (!banner.ccpText) change("ccpText", "Clubcard Price");
  }, [banner, change]);

  useEffect(() => {
    if (formValues) {
      if ("valueTileTop" in formValues) {
        if (togglePower) {
          if (formValues.valueTileTop !== "The power to lower prices") {
            setValueTileData(() => {
              return {
                text: formValues.valueTileTop,
                font: formValues.valueTileTopFont,
              };
            });
            change("valueTileTop", "The power to lower prices");
            change("valueTileTopFont", "14px");
          }
        }
        if (togglePower === false) {
          if (formValues.valueTileTop === "The power to lower prices") {
            change("valueTileTop", valueTileData.text || "");
            change("valueTileTopFont", valueTileData.font || "");
          }
        }
      }
    }
  }, [togglePower, change, formValues, valueTileData]);

  useEffect(() => {
    const key = "valueTileBackground";
    if (vtWhite === true && vt !== "#FFFFFF") change(key, "#FFFFFF");
    if (vtWhite === false && vt === "#FFFFFF") change(key, "#FCD700");
  }, [vtWhite, vt, change]);

  useEffect(() => {
    if (retailer === "tesco" || retailer === "tesco_ie") setHideFields(false);
  }, [retailer]);

  useEffect(() => {
    const { pathname } = location;
    const arr = pathname.split("/");
    if (
      !arr.find((path) => {
        return path === "new";
      })
    ) {
      if (!checkUser(user, banner.advertiser, retailer)) navigate("/");
    }
  }, [location, user, banner.advertiser, retailer, navigate]);

  const getAdvertiser = (advertiser) => {
    return _.find(advertisers, (item) => {
      return item.displayName === advertiser;
    });
  };

  const handleFileUpload = (file, key, title) => {
    let folder = banner.key || key;
    if (file.type.indexOf("image/") === -1) {
      return dispatch(
        fetchError({
          name: "Upload error",
          error: "Wrong file type. Please upload an image - jpg, gif or png",
        })
      );
    }
    uploadFile(file, folder, (data) => {
      dispatch(
        openModal("ProgressModal", {
          size: "tiny",
          progress: data.progress,
          name: file.name,
          title,
          centered: false,
        })
      );
      if (data.progress === 100) {
        change(key, {
          name: data.name,
          path: data.path,
        });
        window.setTimeout(() => dispatch(closeModal()), 1000);
      }
    });
  };

  const handleSubmitForm = async (values) => {
    setShowLoading(true);
    let advertiserId = await getAdvertiser(values.advertiser);
    advertiserId = advertiserId.advertiserId;
    let templateId = values.templateId;
    if (!templateId) {
      templateId = template.id;
    }
    let bespokeTemplate = true;
    let templateType = "bespoke";
    const submitValues = {
      ...values,
      retailer,
      advertiserId,
      templateId,
      bespokeTemplate,
      templateType,
    };
    submitValues.lastModBy = `${user.displayName} (${user.organisation})`;
    //return console.log(submitValues);
    banner.key
      ? updateBanner(submitValues, banner.key, dispatch).then((message) => {
          //console.log(message);
          setShowLoading(false);
        })
      : createBanner(submitValues, dispatch).then((message) => {
          if (message.id) navigate(`/${retailer}/banner/${message.id}`);
          //console.log(message);
        });
  };

  return (
    <>
      <>
        {showFastrade && (
          <Fastrade bannerChange={change} savedTpnb={banner.tpnb} />
        )}
      </>
      <Form onSubmit={handleSubmit(handleSubmitForm)}>
        <Grid padded className="trade-form">
          <Grid.Row>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Header as="h3">Banner info</Header>
              <Field
                name="bannerTitle"
                label="Title"
                type="text"
                component={TextInput}
                placeholder="Add a banner title"
              />
              <Field
                name="adNumber"
                label="Ad number"
                type="text"
                component={TextInput}
                placeholder="Add an ad number"
              />
              <div className="field">
                <div className="field">
                  <label htmlFor="advertiser">Advertiser</label>
                  <Field
                    name="advertiser"
                    component="select"
                    multiple={false}
                    className="ui selection dropdown"
                  >
                    {!user.restrictByAdvertiser && (
                      <option value="">Choose an advertiser</option>
                    )}
                    <AdvertiserOptions advertisers={advertisers} />
                  </Field>
                </div>
              </div>
              <Field
                name="bannerURL"
                label="Banner link"
                type="text"
                component={TextInput}
                placeholder="Add a URL link"
              />
              <Field
                name="tescoEvent"
                label="Tesco event"
                type="text"
                component={TextInput}
                placeholder="Add an Event name"
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Header as="h3">Banner text</Header>
              <Field
                name="headline"
                label="Headline"
                type="text"
                component={TextInput}
                placeholder="Add a headline"
              />
              <Field
                name="subhead"
                label="Subhead"
                type="text"
                component={TextInput}
                placeholder="Add a sub headline"
              />
              <Field
                name="terms"
                label="Terms"
                type="text"
                component={TextInput}
                placeholder="Add terms and conditions"
              />
              <Field
                name="drinkaware"
                label="Include drinkaware"
                type="checkbox"
                component={CheckboxInput}
              />
            </Grid.Column>
            <Grid.Column computer={2} tablet={4} mobile={16}>
              <Header as="h3">Panel values</Header>
              <Field
                name="bgColor"
                label="Background colour"
                type="text"
                component={TextInput}
                placeholder="Add background colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={bg}
                  onSelect={(col) => {
                    change("bgColor", col);
                  }}
                />
              </Field>
              <ColorContrastView background={bg} font={font} />
              <Field
                name="fontColor"
                label="Font colour"
                type="text"
                component={TextInput}
                placeholder="Add font colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={font}
                  onSelect={(col) => {
                    change("fontColor", col);
                  }}
                />
              </Field>
              <Field
                name="panelColor"
                label="Panel colour"
                type="text"
                component={TextInput}
                placeholder="Add panel colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={panel}
                  onSelect={(col) => {
                    change("panelColor", col);
                  }}
                />
              </Field>
              <ColorContrastView background={panel} font={font} />
              <Field
                name="includePanel"
                label="Include panel"
                type="text"
                component={SelectInput}
                options={[
                  { text: "yes", value: "yes", key: "yes" },
                  { text: "no", value: "no", key: "no" },
                ]}
                multiple={false}
              />
              <Field
                name="hidePanel"
                label="Hide panel"
                type="text"
                component={SelectInput}
                options={[
                  { text: "yes", value: "yes", key: "yes" },
                  { text: "no", value: "no", key: "no" },
                ]}
                multiple={false}
              />
              <Field
                name="fiftyfifty"
                label="50/50 split"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="panelOverride"
                label="Override panel"
                type="text"
                component={SelectInput}
                options={[
                  { text: "yes", value: "yes", key: "yes" },
                  { text: "no", value: "no", key: "no" },
                ]}
                multiple={false}
              />
              <Field
                name="ctaColor"
                label="CTA colour"
                type="text"
                component={TextInput}
                placeholder="Add CTA colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={cta}
                  inputName="ctaColor"
                  onSelect={(col) => {
                    change("ctaColor", col);
                  }}
                />
              </Field>
              <Field
                name="chevronColor"
                label="Chevron colour"
                type="text"
                component={TextInput}
                placeholder="Add chevron colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={chevron}
                  inputName="chevronColor"
                  onSelect={(col) => {
                    change("chevronColor", col);
                  }}
                />
              </Field>
              <Field
                name="invertCta"
                label="Invert CTA"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="tescoSearch"
                label="Tesco search (Tesco only)"
                type="checkbox"
                component={CheckboxInput}
              />
            </Grid.Column>
            <Grid.Column computer={2} tablet={4} mobile={16}>
              <Header as="h3">Value tile</Header>
              <Field
                name="newValueTile"
                label="New Value Tile"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="valueTile"
                label="Include VT"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="vtWhite"
                label="No offer tile"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="clubcardPrice"
                label="Clubcard price"
                type="checkbox"
                component={CheckboxInput}
              />
              {retailer === "tesco" && (
                <Field
                  name="threedClubcardTile"
                  label="3D Clubcard tile"
                  type="checkbox"
                  component={CheckboxInput}
                />
              )}
              <Field
                name="includeRegularPrice"
                label="Regular price"
                type="checkbox"
                component={CheckboxInput}
              />
              {!hideFields && (
                <Field
                  name="toggleThePower"
                  label="Toggle the power"
                  type="checkbox"
                  component={CheckboxInput}
                />
              )}
              <Field
                name="valueTileBackground"
                label="VT colour"
                type="text"
                component={TextInput}
                placeholder="Add VT colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={vt}
                  inputName="valueTileBackground"
                  onSelect={(col) => change("valueTileBackground", col)}
                />
              </Field>
              <Field
                name="valueTileColor"
                label="VT font colour"
                type="text"
                component={TextInput}
                placeholder="Add VT font colour"
              >
                <ColorPicker
                  presetColors={presetColors}
                  color={vtFont}
                  inputName="valueTileColor"
                  onSelect={(col) => change("valueTileColor", col)}
                />
              </Field>
              <Field
                name="valueTileTop"
                label="VT top text"
                type="text"
                component={TextInput}
                placeholder="Add VT top text"
              />
              <Field
                name="valueTileTopFont"
                label="Font size"
                type="text"
                component={TextInput}
                placeholder="Add font size in px"
              />
              <Field
                name="strikethrough"
                label="Strikethrough"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="valueTileBottom"
                label="VT bottom text"
                type="text"
                component={TextInput}
                placeholder="Add VT bottom text"
              />
              {hideFields && (
                <>
                  <Field
                    name="decimalPlace"
                    label="Decimal numbers"
                    type="text"
                    component={TextInput}
                    placeholder="Decimal point numbers only"
                  />
                  <Field
                    name="vtCurrency"
                    label="Currency symbol"
                    type="text"
                    component={TextInput}
                  />
                  <Field
                    name="percentSign"
                    label="Percent sign"
                    type="text"
                    component={TextInput}
                    placeholder="Percent sign only"
                  />
                </>
              )}
              <Field
                name="valueTileBottomFont"
                label="Font size"
                type="text"
                component={TextInput}
                placeholder="Add font size in px"
              />
              <Field
                name="includeAsterisk"
                label="Include asterisk"
                type="checkbox"
                component={CheckboxInput}
              />
              <Field
                name="regularPrice"
                label="Regular Price"
                type="text"
                component={SelectInput}
                options={[
                  {
                    text: "Regular Price",
                    value: "Regular Price",
                    key: "regularPriceUk",
                  },
                  {
                    text: "Běžná cena",
                    value: "Běžná cena",
                    key: "regularPriceCz",
                  },
                  {
                    text: "Normál ár",
                    value: "Normál ár",
                    key: "regularPriceHu",
                  },
                ]}
                multiple={false}
              />
              <Field
                name="regularPricePrice"
                label="Regular Price price"
                type="text"
                component={TextInput}
                placeholder=""
              />
              <Field
                name="regularPriceFontSize"
                label="Regular price font size"
                type="text"
                component={TextInput}
                placeholder="Add font size in px"
              />
              <Field
                name="ccpText"
                label="Clubcard text"
                type="text"
                component={TextInput}
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Header as="h3">Images</Header>
              <Field
                name="orientation"
                label="Orientation"
                type="text"
                component={SelectInput}
                options={[
                  { text: "landscape", value: "landscape", key: "landscape" },
                  { text: "portrait", value: "portrait", key: "portrait" },
                ]}
                multiple={false}
              />
              <Field
                name="includePadding"
                label="Padding"
                type="checkbox"
                component={CheckboxInput}
              />
              <div className="field">
                <label>Primary packshot</label>
                {primary && primary.path && (
                  <img src={primary.path} alt="primary packshot" />
                )}
              </div>
              <Field
                name="primaryPackshot"
                component={FileInput}
                fileName={primary && primary.name ? primary.name : ""}
                callback={(file) =>
                  handleFileUpload(file, "primaryPackshot", "Primary packshot")
                }
                handleFileRemove={(e) => change("primaryPackshot", {})}
              />
              <Field
                name="primaryAlt"
                component={TextInput}
                label="Packshot ALT text"
                placeholder="Add a description of the image"
              />
              <div className="field">
                <label>Secondary packshot</label>
                {secondary && secondary.path && (
                  <img src={secondary.path} alt="secondary packshot" />
                )}
              </div>
              <Field
                name="secondaryPackshot"
                component={FileInput}
                fileName={secondary && secondary.name ? secondary.name : ""}
                callback={(file) =>
                  handleFileUpload(
                    file,
                    "secondaryPackshot",
                    "Secondary packshot"
                  )
                }
                handleFileRemove={(e) => change("secondaryPackshot", {})}
              />
              <Field
                name="secondaryAlt"
                component={TextInput}
                label="Packshot ALT text"
                placeholder="Add a description of the image"
              />
              <div className="field">
                <label>Logo</label>
                {logo && logo.path && <img src={logo.path} alt="logo" />}
              </div>
              <Field
                name="logo"
                component={FileInput}
                fileName={logo && logo.name ? logo.name : ""}
                callback={(file) => handleFileUpload(file, "logo", "Logo")}
                handleFileRemove={(e) => change("logo", {})}
              />
              <Field
                name="logoAlt"
                component={TextInput}
                label="Logo ALT text"
                placeholder="Add a description of the image"
              />
              <div className="field">
                <label>Background image</label>
                {bgImage && bgImage.path && (
                  <img src={bgImage.path} alt="background" />
                )}
              </div>
              <Field
                name="background"
                component={FileInput}
                fileName={bgImage && bgImage.name ? bgImage.name : ""}
                callback={(file) =>
                  handleFileUpload(file, "background", "Background image")
                }
                handleFileRemove={(e) => change("background", {})}
              />
              <Field
                name="backgroundPosition"
                label="Background position"
                type="text"
                component={SelectInput}
                options={[
                  { text: "left", value: "left", key: "left" },
                  { text: "right", value: "right", key: "right" },
                ]}
                multiple={false}
              />
              <div className="field">
                <label>Buylist header</label>
                {buylist && buylist.path && (
                  <img src={buylist.path} alt="Buylist header" />
                )}
              </div>
              <Field
                name="buylistHeader"
                component={FileInput}
                fileName={buylist && buylist.name ? buylist.name : ""}
                callback={(file) =>
                  handleFileUpload(file, "buylistHeader", "Buylist header")
                }
                handleFileRemove={(e) => change("buylistHeader", {})}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Menu fixed="bottom" size="mini">
          <Container>
            <Menu.Item>
              <Button
                disabled={submitting || pristine || invalid || showLoading}
                positive
                type="submit"
                loading={showLoading}
                size="mini"
              >
                Save
              </Button>
            </Menu.Item>
            <Menu.Item>
              <CancelButton
                id={banner.key}
                location={location}
                retailer={retailer}
                pristine={pristine}
                size="mini"
              />
            </Menu.Item>
          </Container>
        </Menu>
      </Form>
    </>
  );
};

const max = (value, limit) => {
  return value > limit ? `Please limit to ${limit} characters` : null;
};

const validate = (values) => {
  const isUrlValid = (url) => {
    return url.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
    );
  };

  const hasWhiteSpace = (hex) => {
    return hex.match(/\s/g);
  };

  const errors = {};

  if (!values.bannerTitle) {
    errors.bannerTitle = "Please enter a title";
  }
  if (!values.adNumber || isNaN(Number(values.adNumber))) {
    errors.adNumber = "Please enter a number only";
  }
  if (!values.headline) {
    errors.headline = "Please enter a headline";
  }
  if (!values.advertiser) {
    errors.advertiser = "Please select an advertiser";
  }
  if (values.bannerURL) {
    if (!isUrlValid(values.bannerURL)) {
      errors.bannerURL = "Please enter a valid URL";
    }
    if (isUrlValid(values.bannerURL)) {
      if (hasWhiteSpace(values.bannerURL)) {
        errors.bannerURL = "Please remove any spaces";
      }
    }
  }
  if (values.bgColor) {
    if (hasWhiteSpace(values.bgColor))
      errors.bgColor = "Please remove any spaces";
  }
  if (values.fontColor) {
    if (hasWhiteSpace(values.fontColor))
      errors.fontColor = "Please remove any spaces";
  }
  if (values.panelColor) {
    if (hasWhiteSpace(values.panelColor))
      errors.panelColor = "Please remove any spaces";
  }
  if (values.ctaColor) {
    if (hasWhiteSpace(values.ctaColor))
      errors.ctaColor = "Please remove any spaces";
  }
  if (values.chevronColor) {
    if (hasWhiteSpace(values.chevronColor))
      errors.chevronColor = "Please remove any spaces";
  }
  if (values.valueTileColor) {
    if (hasWhiteSpace(values.valueTileColor))
      errors.valueTileColor = "Please remove any spaces";
  }
  if (values.valueTileBackground) {
    if (hasWhiteSpace(values.valueTileBackground))
      errors.valueTileBackground = "Please remove any spaces";
  }

  return errors;
};

const warn = (values) => {
  const warnings = {};

  if (values.headline) {
    let headMax = values.subhead
      ? max(values.headline.length, 50)
      : max(values.headline.length, 80);
    if (headMax) warnings.headline = headMax;
  }

  if (values.subhead) {
    let subheadMax = values.terms
      ? max(values.subhead.length, 40)
      : max(values.subhead.length, 90);
    if (subheadMax) warnings.subhead = subheadMax;
  }

  if (values.terms) {
    let termsMax = values.subhead
      ? max(values.terms.length, 60)
      : max(values.terms.length, 80);
    if (termsMax) warnings.terms = termsMax;
  }

  return warnings;
};

BannerForm = reduxForm({
  validate,
  form: "bannerForm",
  warn,
})(BannerForm);

const selector = formValueSelector("bannerForm");
BannerForm = connect((state) => {
  const formValues = getFormValues("bannerForm")(state);
  const advertiserValue = selector(state, "advertiser");
  const bg = selector(state, "bgColor");
  const font = selector(state, "fontColor");
  const panel = selector(state, "panelColor");
  const cta = selector(state, "ctaColor");
  const chevron = selector(state, "chevronColor");
  const vt = selector(state, "valueTileBackground");
  const vtFont = selector(state, "valueTileColor");
  const vtWhite = selector(state, "vtWhite");
  const primary = selector(state, "primaryPackshot");
  const secondary = selector(state, "secondaryPackshot");
  const logo = selector(state, "logo");
  const bgImage = selector(state, "background");
  const buylist = selector(state, "buylistHeader");
  const togglePower = selector(state, "toggleThePower");
  return {
    formValues,
    advertiserValue,
    bg,
    font,
    panel,
    cta,
    chevron,
    vt,
    vtFont,
    vtWhite,
    primary,
    secondary,
    logo,
    bgImage,
    buylist,
    togglePower,
  };
})(BannerForm);

export default BannerForm;
